export const convertTimeToMinutes = (hms: string): number => {
  const splitedTime = hms.split(':');
  return +splitedTime[0] * 60 + +splitedTime[1];
};